import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useQuery } from '@tanstack/react-query'

import { RoutingPaths } from 'app/routes/routes'

import { useTourLimits } from 'entities/tour/hooks/useTourLimits'
import searchTour from 'entities/tour/models/search-tour/search-tour'
import tourListStore from 'entities/tour/models/tour-list/tour-list'

import { DestinationFeedItem, MainPageTours } from 'shared/api/tours/main-page'

import { getSearchTourData } from './get-search-tour-data'

export const useTourDirections = () => {
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const { checkHasLimitedTour } = useTourLimits()

  const {
    data: directions = [],
    isLoading,
    isError,
    refetch: requestDirections,
  } = useQuery({
    queryKey: ['tours', 'destination-feed', i18n.language],
    queryFn: ({ signal }) =>
      MainPageTours.getDestinationFeed(signal).then(
        ({ data }) => data.data ?? [],
      ),
    staleTime: 5 * 60 * 1000,
    retry: false,
    networkMode: 'always',
  })

  const selectDirection = (direction: DestinationFeedItem) => {
    checkHasLimitedTour(() => {
      searchTour.setDataForSearchTour(getSearchTourData(direction))
      tourListStore.resetTourList()
      void tourListStore.requestToursList(direction.search_params)
      navigate(RoutingPaths.tours.searchResults.path())
    })
  }

  return {
    directions,
    isLoading,
    isError,
    requestDirections,
    selectDirection,
  }
}
